// Utility function to generate unique IDs
export const generateUniqueId = (prefix = 'field') => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);
  return `${prefix}_${timestamp}_${random}`;
};

export const getJSonSchemaFromFieldInfoList = (
  fieldInfoList,
  selectedFormulaList
) => {
  const propertiesList = {};
  const fieldOrder = []; // Track the order of fields

  const requiredArr = [];
  
  // Ensure we have a valid fieldInfoList and sort by creation order
  const sortedFieldList = [...fieldInfoList].sort((a, b) => {
    // First try to sort by existing displayOrder if available
    if (a.displayOrder !== undefined && b.displayOrder !== undefined) {
      return a.displayOrder - b.displayOrder;
    }
    // Fallback to ID-based sorting for consistent ordering
    if (a.id && b.id) {
      return a.id - b.id;
    }
    // Final fallback to array index
    return 0;
  });

  sortedFieldList.forEach((data, index) => {
    const fieldInput = {};

    if (data["Required"]) {
      requiredArr.push(data["Title"]);
    }
    
    // Ensure each field gets a unique displayOrder
    fieldInput.displayOrder = index;
    
    // Handle conditional fields specially to preserve their properties
    if (data["Type"] === "conditional") {
      Object.keys(data).forEach((key) => {
        // Preserve conditional field properties with their original names
        if (key === "dependentField" || key === "triggerValue" || key === "dependentFieldType" || key === "dependentFieldConfig" || key === "assignedGroup") {
          fieldInput[key] = data[key];
        } else if (key !== "displayOrder") { // Don't lowercase the order
          fieldInput[key.toLocaleLowerCase()] = data[key];
        }
      });
    } else if (data["Type"] === "subheading") {
      Object.keys(data).forEach((key) => {
        // Preserve subheading field properties with their original names
        if (key === "headingLevel" || key === "subheadingDescription") {
          fieldInput[key] = data[key];
        } else if (key !== "displayOrder") { // Don't lowercase the order
          fieldInput[key.toLocaleLowerCase()] = data[key];
        }
      });
    } else {
      // For non-conditional fields, convert all keys to lowercase as before
      Object.keys(data).forEach((key) => {
        if (key !== "displayOrder" && key !== "assignedGroup") { // Don't lowercase these special properties
          fieldInput[key.toLocaleLowerCase()] = data[key];
        } else {
          fieldInput[key] = data[key]; // Keep original casing for special properties
        }
      });
    }

    propertiesList[data["Title"]] = fieldInput;
    fieldOrder.push(data["Title"]); // Track field order
  });

  const response = {
    type: "object",
    title: "",
    required: requiredArr,
    properties: propertiesList,
    description: "",
    formula: selectedFormulaList,
    fieldOrder: fieldOrder, // Save the field order
  };
  return response;
};

export const getLinkJsonReponse = (list) => {
  const reponse = [];
  list.forEach((item) => {
    reponse.push({
      id: item?.id,
      name: item.Title,
      link: item.link,
    });
  });
  return {
    Links: reponse,
  };
};
